import { TableHeadersType } from "../../tableHeadersType";

export const TRIAL_BALANCE_HEADERS: TableHeadersType[] = [
  {
    label: "Ledger Name",
    value: "ledger_name",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Opening Balance",
    value: "opening_balance",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Debit",
    value: "total_debit_amount",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Credit",
    value: "total_credit_amount",
    checked: true,
    defaultChecked: true,
  },
  {
    label: "Closing Balance",
    value: "closing_balance",
    checked: true,
    defaultChecked: true,
  },
];

export const TRIAL_BALANCE_SECTIONS_CONFIG = [
  { key: "equity_json", label: "Equity" },
  { key: "liabilities_json", label: "Liabilities" },
  { key: "tax_payable_json", label: "Tax Payable" },
  { key: "supplier_json", label: "Supplier" },
  { key: "assets_json", label: "Assets" },
  { key: "tax_receivable_json", label: "Tax Receivable" },
  { key: "nature_of_expense_json", label: "Expense" },
  { key: "customer_json", label: "Customer" },
  { key: "payment_json", label: "Cash & Cash Equivalent" },
  { key: "nature_of_income_json", label: "Income" },
  { key: "business_address_json", label: "Business Address" },
];
